define('formkit/view/form.object/design.form.object.view',['require','exports','module','../../templates','./base.form.object.view','./common/design.form.object.top.view'],function(require, exports, module){
  var Templates               = require('../../templates');
  var BaseFormObjectView      = require('./base.form.object.view');
  var DesignFormObjectTopView = require('./common/design.form.object.top.view');

  var DesignFormObjectView = BaseFormObjectView.extend({
    className: 'ui design formObject',

    options: {
      designing: false,
      designable: true,
      disableLabelAndDescriptionInputFields: false,
      readonly: true
    },

    internalViewOptions: BaseFormObjectView.extendInternalViewOptions({
      topView: function() {
        return {
          type: DesignFormObjectTopView,
          form: this.form,
          model: this.model,
          headerText: this.form.getTemplateObjectTypeName(this.model),
          designable: true
        }
      },
      contentView: function() {
        return {
          divided: true,
          designable: true,
          disableLabelAndDescriptionInputFields: this.getOption('disableLabelAndDescriptionInputFields'),
          readonly: true
        }
      }
    }),

    internalViewBindings: {
      topView: {
        designing: 'designing'
      },

      contentView: {
        designing: 'designing'
      }
    },

    onPress: function() {
      this.designing = true;
    },

    onChangeDesigning: function() {
      this.form.trigger('formObject:change:designing', this);
    },

    onTopViewPress: function() {
      this.designing = !this.designing;
    },

    onTopViewActionsViewEditButtonViewPress: function() {
      this.designing = !this.designing;
    }
  });

  module.exports = DesignFormObjectView;
});

